/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CaretContainer_story = {
    readonly " $fragmentRefs": FragmentRefs<"ModerationDropdownContainer_story">;
    readonly " $refType": "CaretContainer_story";
};
export type CaretContainer_story$data = CaretContainer_story;
export type CaretContainer_story$key = {
    readonly " $data"?: CaretContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"CaretContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CaretContainer_story",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ModerationDropdownContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '8a7af49e77f28d3d39d22ae4a664f326';
export default node;
